import { render } from "./gridMenu.vue?vue&type=template&id=451b8b43"
import script from "./gridMenu.vue?vue&type=script&lang=js"
export * from "./gridMenu.vue?vue&type=script&lang=js"

import "./gridMenu.vue?vue&type=style&index=0&id=451b8b43&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__